import services from '@/services.js'

const CUSTOM_GROUP = 'CUSTOM'

const FIELD_TYPES = {
  NUMBER: 1,
  STRING: 2,
  DATE: 3,
  BOOLEAN: 4,
  DATETIME: 5,
  EMAIL: 6,
  MSISDN: 7,
}

const FIELD_VALUES = {
  GENDER: 'GENDER',
  BIRTH_DATE: 'BIRTH_DATE',
  AGE: 'AGE',
  NATIONALITY: 'NATIONALITY',
  AGE_RANGE: 'AGE_RANGE',
}

const getSchema = async (organizationId) => {
  try {
    const fieldTypes = await services.fieldtypes(organizationId)

    const scheme = await services.audienceSchema(organizationId)

    if (scheme.data.data.errorCode === 1000) {
      return [...handleCustomTypes(fieldTypes)]
    }

    return [...scheme.data.data.values, ...handleCustomTypes(fieldTypes)]
  } catch (error) {
    // Implementar casos de erro
  }
}

const handleCustomTypes = (fieldTypes) => {
  let CUSTOMS = fieldTypes.data.data.groups.filter((group) => group.group == CUSTOM_GROUP)

  if (CUSTOMS[0].types.lenght) {
    return CUSTOMS.map((item, index) => {
      return {
        ...item.types[index],
        value: item.types[index].personalizationTag,
      }
    })
  }

  return []
}

export { FIELD_VALUES, FIELD_TYPES, getSchema, handleCustomTypes }
